export var isMember = window.dataLayer[0]["Member and Non Member Reg Type"] != "Non-Member";
export var optedIn = window.dataLayer[0]["Member and Non Member Reg Type"] === "ISF Global Team" ||
    window.dataLayer[0]["I would like to opt-in to the Attendee Chat on the Digital Platform"] === "Yes";
